import { useTranslator } from '@eo-locale/react';
import { useEffect, useState } from 'react';

import type { Filters } from './filters';
import { useFilters } from './filtersContext/filtersContext';
import { useFilterAttributes } from './filterAttributesContext';
import { useProducts } from './productsContext';
import { FormatOption, useFormatFilterValue } from './useFormatFilterValue';

type FiltersKey = keyof Filters;

export const useContentDescription = () => {
  const { products, isSuccess: isProductsFetchedSuccessfuly } = useProducts();
  const { filters } = useFilters();
  const { attributes, isSuccess: isAttributesFetchedSuccessfuly } = useFilterAttributes();
  const formatValue = useFormatFilterValue();
  const { translate } = useTranslator();
  const [value, setValue] = useState('');
  const filterEntries = Object.entries(filters) as Array<[FiltersKey, any]>;

  useEffect(() => {
    if (
      isProductsFetchedSuccessfuly &&
      isAttributesFetchedSuccessfuly &&
      filterEntries.length > 0
    ) {
      setValue(
        filterEntries
          .map(([key, value]) => {
            return (
              translate(mapFilterToTranslateKey(key)) +
              ': ' +
              formatValue[key](value, FormatOption.FullContent)
            );
          })
          .filter((i) => i)
          .join('; ')
      );
    }
  }, [isProductsFetchedSuccessfuly, isAttributesFetchedSuccessfuly]);

  return value;
};

const mapFilterToTranslateKey = (filterKey: FiltersKey) =>
  'product-catalog.filters.' +
  {
    categories: 'categories.title',
    dates: 'date.title',
    languages: 'languages.title',
    location: 'location.title',
    misc: 'miscellaneous',
    price: 'price.title',
    sort: 'sorting.title',
  }[filterKey];
